import type { InputAction } from "./types";

export class Input {
  private listeners: Array<(a: InputAction) => void> = [];
  private lastMove = { x: 0, y: 0 };

  constructor(private canvas: HTMLCanvasElement) {}

  on(cb: (a: InputAction) => void): () => void {
    this.listeners.push(cb);
    return () => (this.listeners = this.listeners.filter((x) => x !== cb));
  }

  mount(): () => void {
    const emit = (a: InputAction) => this.listeners.forEach((cb) => cb(a));

    const toCanvasCoords = (clientX: number, clientY: number) => {
      const rect = this.canvas.getBoundingClientRect();
      const x = (clientX - rect.left) * (this.canvas.width / rect.width);
      const y = (clientY - rect.top) * (this.canvas.height / rect.height);
      return { x, y };
    };

    const onPointerDown = (e: PointerEvent) => {
      this.canvas.setPointerCapture(e.pointerId);
      const p = toCanvasCoords(e.clientX, e.clientY);
      this.lastMove = p;
      emit({ type: "tap", x: p.x, y: p.y });
    };

    const onPointerMove = (e: PointerEvent) => {
      const p = toCanvasCoords(e.clientX, e.clientY);
      this.lastMove = p;
      emit({ type: "move", x: p.x, y: p.y });
    };

    const onKeyDown = (e: KeyboardEvent) => emit({ type: "keydown", key: e.key });
    const onKeyUp = (e: KeyboardEvent) => emit({ type: "keyup", key: e.key });

    this.canvas.addEventListener("pointerdown", onPointerDown);
    this.canvas.addEventListener("pointermove", onPointerMove);
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("keyup", onKeyUp);

    return () => {
      this.canvas.removeEventListener("pointerdown", onPointerDown);
      this.canvas.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("keyup", onKeyUp);
    };
  }

  getPointer() {
    return this.lastMove;
  }
}
